export default function (obj) {
    if (typeof obj === 'undefined') return false;
    if (obj === null) return false;
    return obj.hasOwnProperty('length') && obj.length > 0;
}